if (document.querySelector('.menu-button')) {
	const btn = document.querySelector(".menu-button");
	const menu = document.querySelector(".main-navigation");
	
	// Add Event Listeners
	btn.addEventListener("click", () => {
		menu.classList.toggle("hidden");
		btn.classList.toggle("active");
	});
}

